module.exports = __webpack_public_path__ + "static/img/overseas-4.dabae45.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/overseas-4.png
// module id = nUWq
// module chunks = 1